import React, { ChangeEvent } from 'react';

interface SearchInputProps {
  searchTerm: string;
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

const IconSearch = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
)

export const SearchInput: React.FC<SearchInputProps> = ({ searchTerm, handleChange, placeholder = 'Search...' }) => {
  return (
    <div className="search-input-wrapper">
      <span className="search-icon"><IconSearch /></span>
      <input
        type="text"
        value={searchTerm}
        onChange={handleChange}
        placeholder={placeholder}
        className="search-input"
      />
    </div>
  );
};
